const getResults = (total, _page, perPage) => {
    let $itemsTotalWrapper = $(".items-total-wrapper");

    let from = 0;
    let to = 0;
    _page = _page || 1;
    perPage = perPage || 10;
    if(total != 0) {
        from = _page > 1 ? ((_page - 1) * perPage) + 1 :  _page;

        to = _page * perPage;
        to = to < total ? to : total;
    }

    $itemsTotalWrapper.find(".showingFrom").text(+from);
    $itemsTotalWrapper.find(".showingTo").text(+to);
    $itemsTotalWrapper.find(".showingTotal").text(+total);
}

export default {
    getResults: getResults
};